import { createListLoadingReducer } from './utils';

export default createListLoadingReducer('CUSTOM_FIELD_VALIDATIONS');
